import PropTypes from 'prop-types';
import React from 'react';
import { LinkButton } from '@strava/ui/Button';
import createNetworkingClient from 'utils/networking-client';
import styles from './index.scss';
import { useFeedEntityContext } from '../../../state/FeedEntityContext';
import { indexProps, cursorDataProps } from '../../../props/feed-prop-types';

function BackgroundHeaderImage({ backgroundImage }) {
  return backgroundImage ? (
    <div className={styles.entryMediaContainer}>
      <div className={styles.entryImage}>
        <img
          className={styles.backgroundHeaderImage}
          src={backgroundImage}
          alt=""
          data-testid="promo-img"
        />
      </div>
    </div>
  ) : null;
}

BackgroundHeaderImage.propTypes = {
  backgroundImage: PropTypes.string.isRequired
};

const PromoEntry = ({
  entity,
  description,
  badge,
  backgroundImage,
  impression,
  click,
  headline,
  intersectionObserverRef,
  cursorData,
  index,
  ctaText,
  ctaUrl
}) => {
  const { entityState } = useFeedEntityContext();

  const cardMargin = index > 0 ? styles.cardMargin : '';

  return (
    /* react-feed-entry is being used by feed3 container for pagination - https://github.com/strava/active/blob/main/app/assets/javascripts/strava/dashboard/PaginationView.js.coffee#L52-L73 */
    <div
      className={`react-feed-entry ${styles.feedEntry} ${styles.card} ${cardMargin}`}
      data-updated-at={cursorData.updated_at}
      data-rank={cursorData.rank}
      data-testid="web-feed-entry"
      ref={intersectionObserverRef}
    >
      {/* Background Header Image for Fancy Promo */}
      <BackgroundHeaderImage backgroundImage={backgroundImage} />

      <div className={styles.entryBody}>
        {/* Impression */}
        {impression && (
          <img className={styles.impression} src={impression} alt="" />
        )}

        <div className={styles.media}>
          {/* Left Logo Badge */}
          <div className={styles.mediaLeft}>{badge}</div>

          {/* Right Main Body */}
          <div className={styles.mediaBody}>
            <a
              href={ctaUrl}
              onClick={() => {
                createNetworkingClient({ baseUrl: null, headers: null }).get(
                  click
                );
                entityState.trackAnalytics({
                  action: 'click',
                  element: `${entity.toLowerCase()}_headline_and_description`
                });
              }}
            >
              <h3 className={styles.titleText}>{headline}</h3>
              <div className={styles.details}>{description}</div>
            </a>

            <LinkButton
              variant="primary"
              className={styles.ctaBtn}
              href={ctaUrl}
              onClick={() => {
                createNetworkingClient({ baseUrl: null, headers: null }).get(
                  click
                );
                entityState.trackAnalytics({
                  action: 'click',
                  element: `${entity.toLowerCase()}_cta_button`
                });
              }}
            >
              {ctaText}
            </LinkButton>
          </div>
        </div>
      </div>
    </div>
  );
};

PromoEntry.propTypes = {
  entity: PropTypes.oneOf(['FancyPromo', 'SimplePromo']).isRequired,
  description: PropTypes.string.isRequired,
  impression: PropTypes.string.isRequired,
  click: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string,
  badge: PropTypes.node.isRequired,
  headline: PropTypes.string.isRequired,
  intersectionObserverRef: PropTypes.func.isRequired,
  cursorData: cursorDataProps.isRequired,
  index: indexProps.isRequired
};

PromoEntry.defaultProps = {
  backgroundImage: ''
};

export default PromoEntry;
